<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white cs-contentContainer-right-content cs-fullHeight">
            <el-row class="cs-titleContainer">
              <el-col :span="24">
                <span class="cs-title">学生VIP课程记录</span>
              </el-col>
            </el-row>
            <el-row class="cs-search-conditions margin-top-10" :gutter="20" v-loading="isConditionLoading">
              <el-col :span="4">
                <el-select placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId">
                  <el-option v-for="item in termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-select placeholder="所有(是否新生)" v-model="searchCondition.studentType" size="medium" :disabled="loading">
                  <el-option :key="0" :value="0" label="所有(是否新生)"></el-option>
                  <el-option v-for="item in studentTypes" :key="item.value" :label="item.desc" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4">
                <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search" :disabled="loading" v-model.trim="searchCondition.phone"
                  @keyup.enter.native="search()" />
              </el-col>
              <el-col :span="12" class="cs-buttons">
                <el-button type="primary" :disabled="loading" size="medium" @click="search()">搜索</el-button>
                <el-button v-if="hasAddButton" type="primary" :disabled="loading" size="medium" @click="onAddClick">添加</el-button>
              </el-col>
            </el-row>
            <el-row class="grid-content">
              <table v-if="!!currentStudent.phone" class="area-summary">
                <colgroup>
                  <col width="240" />
                  <col width="200" />
                  <col width="120" />
                  <col width="120" />
                  <col width="120" />
                </colgroup>
                <tr>
                  <th>
                    <span>课程</span>
                  </th>
                  <th>
                    <span>课程备注名</span>
                  </th>
                  <th>
                    <span>课单价(均值)</span>
                  </th>
                  <th>
                    <span>消耗课时(分钟)</span>
                  </th>
                  <th>
                    <span>消耗金额</span>
                  </th>
                </tr>
                <tr v-for="(item, index) in summaryData" :key="index">
                  <td>
                    <span>{{item.CourseGroupName}}</span>
                  </td>
                  <td>
                    <span>{{item.CourseAlias}}</span>
                  </td>
                  <td>
                    <span>{{`${item.UnitPrice}`.toNumber().toFixedEx(2)}}/小时</span>
                  </td>
                  <td>
                    <span>{{`${item.CourseMinutesConsumed}`.toNumber().toFixedEx(2)}}</span>
                  </td>
                  <td>
                    <span>{{`${item.AmountConsumed}`.toNumber().toFixedEx(2)}}</span>
                  </td>
                </tr>
              </table>
              <pagination v-loading="loading" :showSummary="true" :summaryMethod="tableSummaryMethod" :data="tablePageData" :option="paginationOption"
                @search="search" @loadData="onLoadList" @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange" @edit="onPaginationEdit"
                @delete="onPaginationDelete">
                <template #ConsumedDate="{row}">{{$moment.utc(row.ConsumedDate).format("YYYY-MM-DD")}}</template>
                <template #UnitPrice="{row}">{{`${row.UnitPrice}`.toNumber().toFixedEx(2)}}/小时</template>
                <template #CourseMinutesConsumed="{row}">{{`${row.CourseMinutesConsumed}`.toNumber().toFixedEx(2)}}</template>
                <template #AmountConsumed="{row}">{{`${row.AmountConsumed}`.toNumber().toFixedEx(2)}}</template>
              </pagination>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <studentVipCourseRecordEditor key="studentVipCourseRecordEditor" v-ref="(com, key) => $vueRefStore.setChildrenRef(key, com)" :readonly="isReadonly"
      :data="editorData" :termId="currentTermId" :student="currentStudent" @change="onEditorChange" />
  </div>
</template>

<script>
import { getTerms } from "@/service/common.service";
import {
  getStudentVipCourseRecordPageData,
  getStudentVipCourseRecordSummaryData,
  deleteStudentVipCourseRecord,
} from "@/service/enrollmentFee.service";

const default_studentData = {
  termId: null,
  phone: null,
  studentType: 0
};

const default_tablePageData = {
  AdditionalResult: {},
  Columns: [],
  CurrentPage: 1,
  PageCount: 0,
  PageSize: 20,
  RecordCount: 0,
  Results: [],
};

export default {
  name: "studentVipCourseRecordList",
  data() {
    return {
      loading: false,
      isConditionLoading: false,
      pageSize: 20,
      paginationOption: {},
      searchCondition: {
        termId: null,
        phone: null,
        studentType: 0
      },
      termList: [],
      currentTermId: null,
      currentStudent: Object.clone(default_studentData),
      tablePageData: Object.clone(default_tablePageData),
      summaryData: [],
      editorData: null,
      studentTypes:[
        {
          key: "IsNew",
          value: 1,
          desc: "新生"
        },
        {
          key: "IsAuld",
          value: 2,
          desc: "老生"
        }
      ]
    };
  },
  components: {
    navigator: () => import("@/components/navigator"),
    pagination: () => import("@/components/common/pagination"),
    studentVipCourseRecordEditor: () =>
      import("@/components/addCollectFees/studentVipCourseRecordEditor"),
  },
  created() {
    this.paginationOption = {
      displayPagination: true,
      hasEditButton: true,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButtonWithEdit: true,
      fixedAction: "right",
      buttonWidth: 100,
      fnRowEditVisible: (index, row) =>
        row.CreateUserId === this.USERMANAGER.userId,
      fnRowDeleteVisible: (index, row) =>
        row.CreateUserId === this.USERMANAGER.userId,
    };

    this.init();
  },
  computed: {
    hasAddButton() {
      if (
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isFinancial ||
        this.USERMANAGER.isAcademicDirector ||
        this.USERMANAGER.isEducationalAssistant ||
        this.USERMANAGER.isInternationalSales
      )
        return true;

      return false;
    },
    isReadonly() {
      if (
        !(
          this.USERMANAGER.isAdmin ||
          this.USERMANAGER.isFinancial ||
          this.USERMANAGER.isAcademicDirector ||
          this.USERMANAGER.isEducationalAssistant ||
          this.USERMANAGER.isInternationalSales
        )
      )
        return true;

      if (!this.editorData) return false;

      return this.editorData.CreateUserId !== this.USERMANAGER.userId;
    },
    studentSummaryData() {
      if (!this.currentStudent.phone) return [];

      let data = [];

      return data;
    },
  },
  methods: {
    tableSummaryMethod({ columns, data }) {
      let sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }

        if (
          !["CourseMinutesConsumed", "AmountConsumed"].contains(column.property)
        ) {
          sums[index] = String.empty;
          return;
        }

        switch (column.property) {
          case "CourseMinutesConsumed": {
            sums[index] =
              `${this.tablePageData.AdditionalResult["TotalCourseMinutesConsumed"]}`
                .toNumber()
                .toFixedEx(2);
            break;
          }
          case "AmountConsumed": {
            sums[index] =
              `${this.tablePageData.AdditionalResult["TotalAmountConsumed"]}`
                .toNumber()
                .toFixedEx(2);
            break;
          }
        }
      });

      return sums;
    },

    async loadTermsFromServer() {
      try {
        let result = await getTerms(false, true);
        this.termList = !!result && result.success ? result.data : [];
        let currentTerm = null;
        if (this.termList.length > 0) {
          currentTerm = this.termList.find((i) => i.IsCurrentTerm);
          if (!currentTerm) currentTerm = this.termList[0];
        }
        this.searchCondition.termId = !!currentTerm ? currentTerm.Id : null;
      } catch (error) {
        console.error(error);
      }
    },
    async loadStudentVipCourseRecordPageDataFromServer(pageCondtion) {
      this.loading = true;
      try {
        let result = await getStudentVipCourseRecordPageData(pageCondtion);
        if (!!result && result.success) {
          this.tablePageData = result.data;
        } else {
          this.tablePageData = Object.clone(default_tablePageData);

          this.$message.error(result.message);
        }

        this.currentStudent.studentId =
          this.tablePageData.AdditionalResult["StudentId"];
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async loadStudentVipCourseRecordSummaryDataFromServer(pageCondtion) {
      if (!this.currentStudent.phone) {
        this.summaryData = [];
        return;
      }

      try {
        let result = await getStudentVipCourseRecordSummaryData(pageCondtion);
        if (!!result && result.success) {
          this.summaryData = result.data;
        } else {
          this.summaryData = [];

          //this.$message.error(result.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async deleteStudentVipCourseRecordToServer(id) {
      try {
        let result = await deleteStudentVipCourseRecord(id);
        if (!!result && result.success) {
          this.$message({
            message: "删除成功",
            type: "success",
          });

          return true;
        }

        return false;
      } catch (error) {
        console.error(error);
        return false;
      } finally {
        this.isSaving = false;
      }
    },

    async init() {
      await this.loadTermsFromServer();
      await this.search();
    },
    getSearchPageCondition(pageNumber) {
      if (!pageNumber) {
        pageNumber = 1;
      }

      let additionalFilter = {
        termId: this.currentTermId,
        phone: this.currentStudent.phone,
        studentType: this.searchCondition.studentType
      };

      let pageCondition = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        additionalFilter: additionalFilter,
      };

      return pageCondition;
    },
    search(pageNumber) {
      this.currentTermId = this.searchCondition.termId;
      this.currentStudent.phone = this.searchCondition.phone;
      let pageCondition = this.getSearchPageCondition(pageNumber);
      this.loadStudentVipCourseRecordSummaryDataFromServer(pageCondition);
      this.loadStudentVipCourseRecordPageDataFromServer(pageCondition);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.tablePageData.CurrentPage = value;
    },
    openEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentVipCourseRecordEditor"
      );
      if (!refEditor) return;

      refEditor.showDialog();
    },
    closeEditor() {
      let refEditor = this.$vueRefStore.getChildrenRef(
        "studentVipCourseRecordEditor"
      );
      if (!refEditor) return;

      refEditor.closeDialog();
    },
    onAddClick() {
      this.editorData = null;
      this.openEditor();
    },
    onPaginationEdit(index, row) {
      this.editorData = row;
      this.openEditor();
    },
    onPaginationDelete(index, row) {
      this.$confirm("您确定要删除该笔记录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let result = await this.deleteStudentVipCourseRecordToServer(row.Id);
          if (result) {
            this.search();
          }
        })
        .catch(() => {});
    },
    onEditorChange() {
      this.search();
    },
  },
};
</script>

<style lang="scss" scoped>
.cs-buttons {
  text-align: right;
}

.grid-content {
  margin-top: 20px;

  .area-summary {
    width: 100%;

    th,
    td {
      padding: 8px 16px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/admin/studentVipCourseRecordList.vue